/**
 * TextCaption, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/TextCaptionComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const TextCaptionCore = {
  type: 'TextCaption',
  name: 'Text Caption',
  icon: '💬',
  description: 'Small, secondary text for hints, disclaimers, or fine print.',
  category: 'display',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      text: 'Caption text',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Text',
        required: true,
        maxLength: 4096,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.text || properties.text.trim().length === 0) {
      errors.push('Caption text is required');
    }

    if (properties.text && properties.text.length > 4096) {
      errors.push('Caption text must be 4096 characters or less');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    return {
      type: 'TextCaption',
      text: properties.text,
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      text: whatsappComponent.text,
      visible: true,
    };
  },
};
